import { useEffect } from 'react'
import { EventStream } from '../api/events'

export function useEventSubscriber(eventType: string[], callback: (event: any) => void) {
  useEffect(() => {
    const subscription = EventStream.subscribe((event) => {
      if (eventType.includes(event.topic) || eventType.includes('*')) {
        callback(event)
      }
    })

    return () => {
      subscription.unsubscribe()
    }
  }, [eventType, callback])
}
